import { render, staticRenderFns } from "./AddMandateModal.vue?vue&type=template&id=7d587beb&scoped=true&"
import script from "./AddMandateModal.vue?vue&type=script&lang=js&"
export * from "./AddMandateModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMandateModal.vue?vue&type=style&index=0&id=7d587beb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d587beb",
  null
  
)

export default component.exports